(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/andra-chansen/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/andra-chansen/assets/javascripts/prescript.js');

'use strict';



svs.numbergames = svs.numbergames || {};
svs.numbergames.andra_chansen = svs.numbergames.andra_chansen || {};
svs.numbergames.andra_chansen.rowBanners = svs.numbergames.andra_chansen.rowBanners || {};
svs.numbergames.ReactAndraChansen = svs.numbergames.ReactAndraChansen || {};
svs.numbergames.andra_chansen.logger = new svs.core.log.Logger('numbergames:andra_chansen');

 })(window);